import { Services } from '@/infra/services';
import { type Response as CartSummaryResponse } from '@/infra/services/checkout/cart/get-cart-summary';

export interface GetCartSummaryProps {
  cartId: string;
}

export async function getCartSummary(
  props: Readonly<GetCartSummaryProps>
): Promise<CartSummaryResponse> {
  const { cartId } = props;

  return await Services.Checkout.Cart.getCartSummary({ cartId });
}
